import React from 'react';
import {useAuth} from 'hooks/useAuth';
import {Route, Redirect} from 'react-router-dom';

/**
 * Route component that checks user permissions before rendering
 * @component
 * @param {Object} props
 * @param {string[]} props.permissions - Array of permission slugs required to access the route
 * @param {Function} props.predicate - Predicate function to check if the user has access to the route
 * @param {string} props.path - Route path
 * @returns {React.Component} Route component or Redirect
 */
export default function RestrictedRoute({
	permissions = [],
	predicate = () => true,
	...props
}) {
	const {user} = useAuth();
	const userPermissionSlugs = (user?.permissions || []).map(p => p.slug);
	const canAccess =
		permissions.every(permission => userPermissionSlugs.includes(permission)) &&
		predicate(user);

	return canAccess ? <Route {...props} /> : <Redirect exact path={props.path} to="/" />;
}
